export const pricingData = {
	yearly: [
		{
			title: "Personal",
			features: [
				"Up to 3 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$29",
			salePrice: "$15",
			link: "https://pickplugins.lemonsqueezy.com/buy/7d06a6f8-0d94-47f6-9950-53699ffd91ce?enabled=729665&checkout%5Bcustom%5D%5Bproduct_id%5D=141913",
		},
		{
			title: "Plus",
			features: [
				"Up to 10 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$75",
			salePrice: "$45",
			link: "https://pickplugins.lemonsqueezy.com/buy/b85af377-e91b-4eaa-8f81-fcefdd9f48e8?enabled=729668&checkout%5Bcustom%5D%5Bproduct_id%5D=141914",
		},

		{
			title: "Agency",
			features: [
				"Up to 500 Sites",
				"1 Year of Updates",
				"1 Year Free Support",
				"Access to All PRO Features",
			],
			price: "$149",
			salePrice: "$99",
			link: "https://pickplugins.lemonsqueezy.com/buy/895f0a9d-54da-4fe1-995c-45a9605adb51?enabled=729670&checkout%5Bcustom%5D%5Bproduct_id%5D=141915",
		},
	],
	lifetime: [
		{
			title: "Personal",
			features: [
				"Up to 3 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$99",
			salePrice: "$49",
			link: "https://pickplugins.lemonsqueezy.com/buy/78a9cb98-1cd3-489d-b860-f28f8766987b?enabled=729667&checkout%5Bcustom%5D%5Bproduct_id%5D=141916",
		},
		{
			title: "Plus",
			features: [
				"Up to 10 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$149",
			salePrice: "$99",
			link: "https://pickplugins.lemonsqueezy.com/buy/81aa14ac-50a5-4a36-95f0-a3ebfa54bcb0?enabled=729669&checkout%5Bcustom%5D%5Bproduct_id%5D=141917",
		},

		{
			title: "Agency",
			features: [
				"Up to 500 Sites",
				"Lifetime Free Updates",
				"Lifetime Support",
				"Access to All PRO Features",
			],
			price: "$199",
			salePrice: "$149",
			link: "https://pickplugins.lemonsqueezy.com/buy/096b7156-7a54-4718-95b3-20028299c401?enabled=729671&checkout%5Bcustom%5D%5Bproduct_id%5D=141918",
		},
	],
};
